import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex p-0 transition-opacity outline-none',
    plusIcon: 'absolute -right-[2px] -bottom-[1px]'
  },
  variants: {
    isInCart: {
      true: {
        base: 'bg-blue md:opacity-100'
      }
    }
  },
  defaultVariants: {
    isInCart: false
  }
});
